import stringHelper from './stringHelper';

const PROPERTY_STATUS_DISPLAY_TEXTS: Record<string, string> = {
  // oxlint-disable-next-line constellation-content/word-list
  'OFF-MARKET': 'Off market',
};

const getPropertyStatusLabel = (status?: string | null) =>
  (status && PROPERTY_STATUS_DISPLAY_TEXTS[status.toUpperCase()]) ?? stringHelper.sentenceCase(status);

export { getPropertyStatusLabel };
